import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const REAL_REVIEW = {
  name: "Maria Teresa T.",
  tag: "Intervento di implantologia · recensione Google",
  text: "Esperienza positiva, che dire!! Gentili professionali competenti.\nUn grazie al Dr.Gattuso, chirurgo maxillofacciale, che ha eseguito l'intervento di implantologia, professionale e rassicurante nonostante le problematiche da affrontare.\nUn ringraziamento al Dr.Kola Ditran che mi ha seguita con professionalità ed empatia, attento oltre alla tecnica del lavoro anche alle mie esigenze estetiche, rispondendo sempre ed esaustivamente a qualunque chiarimento richiesto.\nDisponibilità e gentilezza anche da parte di Silvia, assistente alla poltrona e Francesca in segreteria.",
};

export function GoogleBadge() {
  return (
    <a
      href="https://www.google.com/maps/search/?api=1&query=Dentalchivasso+Via+Gerbido+15%2F3+Chivasso"
      target="_blank"
      rel="noreferrer"
      data-testid="google-rating-badge"
      className="group inline-flex items-center gap-3.5 rounded-3xl border border-line bg-paper px-6 py-4 hover:border-gold/50 hover:shadow-lift transition-all duration-300"
    >
      <svg width="26" height="26" viewBox="0 0 48 48" aria-hidden="true" className="shrink-0">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
      </svg>
      <span className="font-display text-5xl font-semibold text-ink">4,7</span>
      <span>
        <span className="flex gap-0.5 text-gold">
          {[...Array(5)].map((_, s) => (
            <Star key={s} size={14} fill="currentColor" strokeWidth={0} />
          ))}
        </span>
        <span className="mt-1 block text-xs text-mutedc">19 recensioni su Google</span>
      </span>
    </a>
  );
}

export default function Testimonials() {
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-32" data-testid="testimonials-section">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <Reveal>
          <Eyebrow>Recensioni dei pazienti</Eyebrow>
          <h2 className="mt-5 font-display font-medium tracking-tight text-ink text-4xl md:text-5xl leading-[1.08] max-w-2xl">
            Le parole di chi <span className="italic text-teal">ci ha scelto.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <GoogleBadge />
        </Reveal>
      </div>

      <div className="mt-14 grid lg:grid-cols-3 gap-6">
        <Reveal className="lg:col-span-2 h-full">
          <figure
            className="rounded-3xl border border-line bg-paper p-8 md:p-10 h-full flex flex-col hover:shadow-lift transition-shadow duration-500"
            data-testid="testimonial-real-card"
          >
            <div className="flex items-center justify-between">
              <div className="flex gap-1 text-gold" aria-label="Valutazione 5 stelle su 5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <Quote size={30} className="text-teal/25" strokeWidth={1.5} />
            </div>
            <blockquote className="mt-6 flex-1 font-display text-xl md:text-2xl leading-relaxed text-ink/85 whitespace-pre-line">
              “{REAL_REVIEW.text}”
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-line flex items-center justify-between flex-wrap gap-2">
              <p className="font-semibold text-sm text-ink">{REAL_REVIEW.name}</p>
              <p className="text-xs text-mutedc">{REAL_REVIEW.tag}</p>
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.08} className="h-full">
          <figure
            className="rounded-3xl border border-line bg-paper p-8 h-full flex flex-col hover:shadow-lift transition-shadow duration-500"
            data-testid="testimonial-real-card-2"
          >
            <div className="flex items-center justify-between">
              <div className="flex gap-1 text-gold" aria-label="Valutazione 5 stelle su 5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <Quote size={26} className="text-teal/25" strokeWidth={1.5} />
            </div>
            <blockquote className="mt-5 flex-1 font-display text-xl leading-relaxed text-ink/85">
              “Ringrazio Dottor Kola: pulizia protesi fissa accurata e inoltre è disponibile, preparato e paziente. Grazie anche a tutto lo staff.”
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-line">
              <p className="font-semibold text-sm text-ink">Giovanna B.</p>
              <p className="text-xs text-mutedc mt-0.5">Pulizia protesi fissa · recensione Google</p>
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.14} className="h-full">
          <figure
            className="rounded-3xl border border-line bg-teal-mist/40 p-8 flex flex-col hover:shadow-lift transition-shadow duration-500"
            data-testid="testimonial-real-card-3"
          >
            <div className="flex gap-1 text-gold" aria-label="Valutazione 5 stelle su 5">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <blockquote className="mt-5 flex-1 font-display text-xl leading-relaxed text-ink/85">
              “Professionalità al massimo, consiglio vivamente. Staff disponibile.”
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-teal/20">
              <p className="font-semibold text-sm text-ink">Ettore A.</p>
              <p className="text-xs text-mutedc mt-0.5">Recensione Google</p>
            </figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.18} className="lg:col-span-2 h-full">
          <figure
            className="rounded-3xl border border-line bg-paper p-8 flex flex-col hover:shadow-lift transition-shadow duration-500"
            data-testid="testimonial-real-card-4"
          >
            <div className="flex items-center justify-between">
              <div className="flex gap-1 text-gold" aria-label="Valutazione 5 stelle su 5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <Quote size={26} className="text-teal/25" strokeWidth={1.5} />
            </div>
            <blockquote className="mt-5 flex-1 font-display text-xl leading-relaxed text-ink/85">
              “Grazie al Dott. Kola per disponibilità e bravura, un ringraziamento al Professor Gattuso per la sua grande professionalità, e a tutto lo staff per l'attenzione e la gentilezza. Prezzi ottimi. Consigliato.”
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-line">
              <p className="font-semibold text-sm text-ink">Bianca D.</p>
              <p className="text-xs text-mutedc mt-0.5">Recensione Google</p>
            </figcaption>
          </figure>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <p className="mt-10 text-sm text-mutedc" data-testid="testimonials-source-note">
          Valutazione media 4,7/5 basata su 19 recensioni Google.{" "}
          <a
            href="https://www.google.com/maps/search/?api=1&query=Dentalchivasso+Via+Gerbido+15%2F3+Chivasso"
            target="_blank"
            rel="noreferrer"
            data-testid="testimonials-google-link"
            className="font-semibold text-teal hover:text-teal-deep underline underline-offset-4"
          >
            Leggi tutte le recensioni su Google
          </a>
        </p>
      </Reveal>
    </section>
  );
}